// main - header shadow 제거
document.addEventListener("DOMContentLoaded", function() {
  if (window.location.pathname === "/") { 
    let header = document.querySelector("#sticky-header-content"); 
    if (header) {
      header.style.boxShadow = "none"; 
    }
  }
});




